(function () {
  'use strict';

  var host = document.querySelector('[data-pdp-v3]');
  if (!host) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('PdpV3Data').textContent); } catch (e) {}

  var S = { plan: 'b1' };
  try {
    var savedPlan = sessionStorage.getItem('pdpV3Plan');
    if (savedPlan === 'b1' || savedPlan === 'b2') S.plan = savedPlan;
    sessionStorage.removeItem('pdpV3Plan');
  } catch (e) {}

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- size: everything switches in place from DATA (no fetch, no transition) ---------- */
  function render() {
    var p = DATA[S.plan];
    $$('.x-plan[data-plan]').forEach(function (el) { el.setAttribute('aria-checked', el.getAttribute('data-plan') === S.plan); });
    var ship = document.querySelector('[data-v3-ship]');
    if (ship) ship.textContent = ship.getAttribute('data-' + S.plan);
    if (p) {
      $$('[data-v3-price="ship"]').forEach(function (el) { el.textContent = p.ship.price; });
      $$('[data-v3-price="pre"]').forEach(function (el) { el.textContent = p.pre.price; });
    }
    $$('[data-v3-show]').forEach(function (el) { el.hidden = el.getAttribute('data-v3-show') !== S.plan; });
  }

  document.addEventListener('click', function (e) {
    var plan = e.target.closest('.x-plan[data-plan]');
    if (plan) { S.plan = plan.getAttribute('data-plan'); render(); showHeroSlide(); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.x-plan[role="radio"]')) {
      e.preventDefault(); e.target.click();
    }
  });

  /* ---------- flavour: V1's product switch (link + scroll memory), keeping ?view / ?pdp and the size ---------- */
  function initFlavourLinks() {
    var params = new URLSearchParams(window.location.search);
    $$('[data-v3-flavour-link]').forEach(function (a) {
      try {
        var url = new URL(a.getAttribute('href'), window.location.origin);
        ['view', 'pdp'].forEach(function (k) { if (params.has(k)) url.searchParams.set(k, params.get(k)); });
        a.setAttribute('href', url.pathname + url.search);
      } catch (err) {}
      a.addEventListener('click', function (e) {
        if (a.getAttribute('aria-checked') === 'true') { e.preventDefault(); return; }
        try {
          sessionStorage.setItem('flavourScrollY', window.scrollY);
          sessionStorage.setItem('pdpV3Plan', S.plan);
        } catch (err) {}
      });
    });
    var savedScroll = null;
    try { savedScroll = sessionStorage.getItem('flavourScrollY'); sessionStorage.removeItem('flavourScrollY'); } catch (err) {}
    if (savedScroll !== null) {
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'instant' });
      }); });
    }
  }

  /* ---------- size change brings the hero slide into view (as V1 does on variant change) ---------- */
  function showHeroSlide() {
    var layer = document.querySelector('[data-v3-hero]');
    var slide = layer && layer.closest('[data-media-id]');
    var gallery = slide && slide.closest('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(slide.getAttribute('data-media-id'), false);
  }

  // the 1 Month Free hero image is lazy (hidden); fetch it once the page has loaded so the swap is instant
  window.addEventListener('load', function () {
    $$('[data-v3-hero] [data-v3-show] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  });

  /* ---------- hero layer sits on the photo box itself, so it matches the image edges ---------- */
  function initHero() {
    var layer = document.querySelector('[data-v3-hero]');
    if (!layer) return;
    var box = layer.parentElement.querySelector('.product-media-container');
    if (!box) return;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.appendChild(layer);
  }

  /* ---------- accordions: all closed on load, one open at a time ---------- */
  function initAccordions() {
    var accs = $$('.x-acc');
    accs.forEach(function (d) {
      d.open = false;
      d.addEventListener('toggle', function () {
        if (d.open) accs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- rating link scrolls to the reviews on this page (V2 fix) ---------- */
  function initReviewLink() {
    $$('.v3-rating a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector('[id$="__video_section_GwYNtD"]');
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
        var y = target.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0);
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* ---------- add to cart ----------
     1 Month Supply: V1 behaviour.  1 Month Free: V2 behaviour (60-serving + free pouch, one call).
     Ship now: add, let free-gift-item.js add the welcome kit, wait for it (6s cap), then checkout.
     Pre-order: add, add the welcome kit directly (V1 pre-order button), then checkout. */
  function buildItems(mode) {
    var p = DATA[S.plan];
    var line = p[mode];
    var items = [{ id: line.id, quantity: 1, selling_plan: line.plan }];
    if (S.plan === 'b2' && p.freePouch) {
      items.push({ id: p.freePouch, quantity: 1, properties: { _free_pouch: 'Buy 2, Get 1 Free', _paired_with: String(line.id) } });
    }
    return items;
  }

  // progress feedback: both buttons lock (no double add); the clicked one reads "Adding..." as V1's pre-order button does.
  // Same text on both buttons: clearer than V1's small spinner and no extra assets.
  function lockButtons(on, clicked) {
    $$('[data-v3-atc]').forEach(function (b) {
      b.disabled = on;
      var label = b.querySelector('.preorder-btn__main') || b.querySelector('.text');
      if (on && b === clicked && label) {
        b.classList.add('loading');
        label.setAttribute('data-v3-label', label.innerHTML);
        label.innerHTML = 'Adding...';
        $$('.ButtonDotSeparator, .value', b).forEach(function (el) { el.style.display = 'none'; });
      } else if (!on) {
        b.classList.remove('loading');
        if (label && label.hasAttribute('data-v3-label')) {
          label.innerHTML = label.getAttribute('data-v3-label');
          label.removeAttribute('data-v3-label');
        }
        $$('.ButtonDotSeparator, .value', b).forEach(function (el) { el.style.display = ''; });
      }
    });
    if (!on) render(); // restored label shows the current size's price
  }

  function goToCheckoutAfterGiftSync() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.style.display = 'none';
    var done = false;
    function go() {
      if (done) return;
      done = true;
      document.removeEventListener('cart:subscriptionSynced', go);
      window.location.href = '/checkout';
    }
    document.addEventListener('cart:subscriptionSynced', go);
    if (typeof checkSubscriptionInCart === 'function') checkSubscriptionInCart();
    setTimeout(go, 6000);
  }

  function submit(mode, btn) {
    var err = document.querySelector('[data-v3-atc-error]');
    if (err) err.style.display = 'none';
    var items = buildItems(mode);
    if (items.some(function (i) { return !i.id; })) {
      if (err) { err.textContent = 'Something went wrong. Please try again.'; err.style.display = 'block'; }
      return;
    }
    lockButtons(true, btn);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('Cart error'); return r.json(); })
      .then(function () {
        if (mode === 'pre') {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: DATA[S.plan].pre.kit, quantity: 1 })
          })
            .catch(function () {})
            .then(function () { window.location.href = '/checkout'; });
        }
        goToCheckoutAfterGiftSync();
      })
      .catch(function () {
        lockButtons(false);
        if (err) { err.textContent = 'Something went wrong. Please try again.'; err.style.display = 'block'; }
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-v3-atc]');
    if (!b || b.disabled) return;
    submit(b.getAttribute('data-v3-atc') === 'pre' ? 'pre' : 'ship', b);
  });

  // back button from checkout restores the cached page: reset the drawer and the buttons
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.close === 'function') drawer.close();
      drawer.classList.remove('active', 'animate');
      drawer.style.display = '';
    }
    document.body.classList.remove('overflow-hidden');
    lockButtons(false);
  });

  /* ---------- attribution: ?pdp=v3 is written to the cart as the "pdp" attribute ---------- */
  function initCartAttribute() {
    var pdp = new URLSearchParams(window.location.search).get('pdp');
    if (!pdp || !/^[a-z0-9]{1,12}$/i.test(pdp)) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes.pdp === pdp) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { pdp: pdp } })
        });
      })
      .catch(function () {});
  }

  function init() {
    render();
    initFlavourLinks();
    initHero();
    initAccordions();
    initReviewLink();
    initCartAttribute();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
